// extracted by mini-css-extract-plugin
export default {"btnRow":"TeltonikaCard_btnRow__9HBIE"};